module.exports = __webpack_public_path__ + "img/data-viz.62d4dc2b.png";